import { Periods, RideStatusLabels } from "../../helpers/enums";
import { general } from "../../locales/general";
import BoxWrapper from "../BoxWrapper";
import DateFilters from "../DateFilters";
import Pagination from "../Pagination";
import RenderTable from "../RenderTable";
import SimpleUserRidersTable from "./tables/UserRides";

interface Props {
  rideFilters: any;
  setRideFilters: (filters: any) => void;
  isLoading: boolean;
  rides: any;
  handleRidePageChange: (page: number) => void;
  setDates: (dates: any) => void;
  defaultPeriod?: Periods;
}

export const RidesTab: React.FC<Props> = ({
  rideFilters,
  setRideFilters,
  isLoading,
  rides,
  handleRidePageChange,
  setDates,
  defaultPeriod,
}) => {
  return (
    <div className="p-4 border bg-white rounded-4">
      <h2 className="text-xl font-bold mb-4">Trajets</h2>

      {/* Filters */}
      <div className="d-flex  align-items-center gap-4 px-3 mt-4"></div>

      {/* Summary Box */}
      <BoxWrapper>
        <div className="d-flex align-items-center justify-content-between gap-4 mb-3">
          <div className="m-3 d-flex justify-content-between gap-4 ">
            <div>
              <label htmlFor="status">Statut</label>
              <select
                name="status"
                id="status"
                className="form-select"
                onChange={(e) =>
                  setRideFilters((prev: any) => ({
                    ...prev,
                    status: e.target.value,
                    page: 1,
                  }))
                }
                value={rideFilters.status}
              >
                <option value="">Tous</option>
                {Object.entries(RideStatusLabels).map(([key, label]) => (
                  <option key={key} value={key}>
                    {label}
                  </option>
                ))}
              </select>
            </div>
            {/* dates */}
            <DateFilters
              label="Date"
              onChange={setDates}
              defaultPeriod={defaultPeriod}
            />
          </div>
          {rides.items.length > 0 && (
            <div
              className="d-flex align-items-end fs-5 fw-bold m-0  text-white  w-auto gap-1 bg-gradient-primary p-3 text-white mb-2"
              style={{ alignSelf: "flex-end", borderTopRightRadius: "8px" }}
            >
              <span className="me-2">Trajets :</span>
              <strong>{rides.meta.totalItems || 0}</strong>
            </div>
          )}
        </div>

        {/* Rides Table */}
        <RenderTable
          loading={isLoading && !rides.items.length}
          render={() => {
            if (isLoading && !rides.items.length) {
              return null;
            }

            if (!isLoading && !rides.items.length) {
              return (
                <p className="text-center fs-5 my-2">{general.fr.noData}</p>
              );
            }

            return <SimpleUserRidersTable rides={rides.items} />;
          }}
        />
      </BoxWrapper>

      {/* Pagination */}
      {rides.meta.totalPages > 1 && (
        <Pagination
          currentPage={rideFilters.page}
          onPageChange={handleRidePageChange}
          totalCount={rides.meta.totalPages || 0}
          pageSize={rideFilters.limit}
          siblingCount={1}
        />
      )}
    </div>
  );
};
